export default __webpack_public_path__ + "static/media/billard-clipart-pool-table-3.d0e7f12d.png";